export default __webpack_public_path__ + "static/media/fb.1c5d7f83.svg";